import styled from "styled-components";
import FormLayoutHandler from "../../layouts/FormLayoutHandler";
import { ALL_BOOKINGS } from "../../../utils/constants";
import GuestLayout from "../../layouts/GuestLayout";

export const RegisterBookings = () => {
  return (
    <GuestLayout>
      <div className="flexCenter x100 mt-5">
        <Wrapper>
          <FormLayoutHandler source_id={ALL_BOOKINGS} />
        </Wrapper>
      </div>
    </GuestLayout>
  );
};

const Wrapper = styled.div`
  width: 100%;
  padding: 20px clamp(16px, 4vw, 48px) 0;

  /* Flat surface to match the landing page — this replaces the
     patternGradient backdrop removed along with the other gradients. */
  background: var(--lp-bg-alt);
`;
